import icons from "@/assets/icon/svgs.js";
export default {
  name: "SvgIcon",
  props: {
    icon: {
      type: String,
      required: true
    }
  },
  computed: {
    svgContent() {
      return icons[this.icon] || "";
    }
  }
};